import type { PropsWithChildren } from 'react'
import { createContext, useContext, useMemo } from 'react'
import * as React from 'react'

import config from 'constants/config'

interface MapboxContextProps {
  isLoaded: boolean
  accessToken?: string
}

const MapboxContext = createContext<MapboxContextProps>({
  isLoaded: false,
  accessToken: undefined,
})

export const useMapboxContext = () => {
  return useContext(MapboxContext)
}

interface EnsureMapboxLoadedProps {
  loadingElement?: React.ReactNode
  children: React.ReactNode
}

export function EnsureMapboxLoaded({ loadingElement = null, children }: EnsureMapboxLoadedProps) {
  const { isLoaded } = useMapboxContext()

  return <>{isLoaded ? children : loadingElement}</>
}

export function MapboxProvider(props: PropsWithChildren) {
  const accessToken = config.MAP_BOX_API_KEY

  const value = useMemo<MapboxContextProps>(() => ({
    isLoaded: Boolean(accessToken),
    accessToken,
  }), [accessToken])

  return (
    <MapboxContext.Provider value={value}>
      {props.children}
    </MapboxContext.Provider>
  )
}
